<template>
  <div class="table-box card-base box grow invoices-base-summary" id="table-wrapper">
    <el-table
      :data="invoices"
      style="width:100%"
      :cell-style="{ padding: '4px' }"
      stripe
      header-row-class-name="fs-12"
      :empty-text="$t('invoices.noInvoices')"
    >
      <el-table-column :label="$t('invoices.invoiceNumber')" min-width="180">
        <template slot-scope="scope">
          <PortausLink
            :id="scope.row.id"
            :label="invoiceNumber(scope.row)"
            path="/invoices/"
            :underline="true"
          ></PortausLink>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.dueDate')" min-width="140">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.dueDate || scope.row.due_date) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('invoices.customer')" min-width="220">
        <template slot-scope="scope">
          <span>{{ customerName(scope.row.customer) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.status')" min-width="140">
        <template slot-scope="scope">
          <el-tag :type="getInvoiceTagType(scope.row.status)" size="small">
            {{ $t(`invoices.statuses.${statusCode(scope.row)}`) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('invoices.total')" min-width="140" align="right">
        <template slot-scope="scope">
          <span>{{ formatCurrency(scope.row.totalAmount, scope.row.currency && scope.row.currency.code) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('invoices.paidAmount')" min-width="140" align="right">
        <template slot-scope="scope">
          <span>{{ formatCurrency(scope.row.paidAmount, scope.row.currency && scope.row.currency.code) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('invoices.outstandingAmount')" min-width="140" align="right">
        <template slot-scope="scope">
          <span>{{ formatCurrency(scope.row.balance, scope.row.currency && scope.row.currency.code) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link';

export default {
  name: 'Invoices-base-summary',
  props: {
    invoices: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PortausLink
  },
  methods: {
    invoiceNumber(invoice) {
      if (invoice.invNumber != null && invoice.invNumber !== '') return invoice.invNumber;
      if (invoice.inv_number != null && invoice.inv_number !== '') return invoice.inv_number;
      return `#${invoice.id}`;
    },
    customerName(customer) {
      if (customer == null) return '--';
      const usualName = customer.usualName != null ? customer.usualName : customer.usual_name;
      if (usualName != null && `${usualName}`.trim() !== '') return usualName;
      return customer.name != null && `${customer.name}`.trim() !== '' ? customer.name : '--';
    },
    statusCode(invoice) {
      return invoice != null && invoice.status != null && invoice.status.code != null ? invoice.status.code : 'DRAFT';
    },
    formatDate(date) {
      if (date == null || date === '') return '--';
      return moment(date).format('L');
    },
    formatCurrency(amount, currencyCode) {
      const value = amount != null ? amount : 0;
      if (currencyCode != null && currencyCode !== '') {
        return this.$n(value, 'currency', currencyCode);
      }
      return this.$n(value, 'currency');
    }
  },
  computed: {
    ...mapGetters('invoices', ['getInvoiceTagType'])
  }
};
</script>

<style scoped>
.invoices-base-summary {
  padding-bottom: 12px;
}
</style>
